/**
 * Fire Meta Pixel standard "Lead" for app install clicks (Android / iPhone).
 * Pixel is initialized in public/index.html. No-op if the script has not loaded.
 */
export function trackMetaInstallLead(platform) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq('track', 'Lead', {
    content_name: platform,
    content_category: 'app_install',
  });
}
